/**
 * The workbook panel type: a Workbook report — a spreadsheet of one or more sheets (merged bands,
 * fonts, fills, borders, number formats, frozen panes), written by the transform as a workbook spec,
 * shown as an interactive grid and downloaded as the xlsx it writes. See
 * docs/plans/active/cirra/2026-10-07-analytics-report-formats (ADR 004).
 */

const workbook = {
  /* `reportFormat`: one of the shapes a report page's one panel may take (ADR 001). Not `advanced`:
     the spec is compiled and validated when the panel cooks, the same rule as document and html. */
  names: [
    {
      id: 'workbook',
      label: 'Workbook',
      formatLabel: 'Workbook',
      phrase: 'a workbook',
      guide: 'workbook.md',
      companionGuides: ['report-ai-snippets.md'],
      reportFormat: true,
      advanced: false,
      toolSummary: 'a spreadsheet of one or more sheets — merged cells, fonts, fills, borders, number formats, frozen panes — that the transform writes as a workbook spec; readers work in it as a grid and download it as xlsx',
      promptSummary: 'a spreadsheet of one or more styled sheets the transform writes as a workbook spec, shown as an interactive grid and downloaded as an Excel file — for a report people work in or circulate as a spreadsheet, or that reproduces one'
    }
  ],
  block: 'workbook',
  /* One column of the first row holds the whole workbook spec { styles, sheets }, the same one-row
     shape as the report and document types. */
  fields: {
    key: { kind: 'string', required: true, clearable: true, hint: 'the whole workbook lives in one column of the first row, as { styles, sheets }', label: 'Workbook column' }
  },
  editorHint: "One row is one workbook: the first row's value at this column is { styles, sheets } — every sheet's rows, cells, merges and styles — written by the transform. A column named workbook is picked up automatically.",
  stateSummary: ({ block, type }) => (type === 'workbook' ? `workbook: body key ${block.key || 'workbook'}` : ''),
  toolSchema: {
    type: ['object', 'null'],
    additionalProperties: false,
    required: ['key'],
    description: 'Workbook mapping (displayType "workbook"): the FIRST data row\'s value at this key is the ENTIRE workbook spec — { styles, sheets } — that the transform writes from the data. Omit the WHOLE block (or send null) to fall back to a column named "workbook". MANDATORY before authoring: knowledge_read immutable/analytics/panel-types/workbook.md — a spec outside it fails the cook.',
    properties: {
      key: { type: 'string', description: 'Column holding the workbook spec { styles, sheets }.' }
    }
  }
};

export default workbook;
